<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/ff1.png" class="flor flor-1" alt="" />
    <img src="@/assets/ff2.png" class="flor flor-2" alt="" />
    <img src="@/assets/ff3.png" class="flor flor-3" alt="" />

    <!-- NUEVAS FLORES -->
    <img src="@/assets/ff.png" class="flor flor-4" alt="" />
    <img src="@/assets/ff1.png" class="flor flor-5" alt="" />
    <img src="@/assets/ff2.png" class="flor flor-6" alt="" />

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <div class="imagen-xv-wrapper">
      <img src="@/assets/IMG_4935.webp" class="imagen-xv" alt="Main photo" />
    </div>

    <!-- TEXTO -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        With God's blessing <br />
        and the love of our parents
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista">Jilary &nbsp;Díaz</h1>
      <h1 class="nombre-protagonista">Miguel &nbsp;&nbsp;De &nbsp; Jesús</h1>

          <!-- hhgIjhkMAGEeeNhgh

 <div class="separador-elegante"></div>

      <p class="frase-bendicion">Our Godparents</p>

      <h1 class="nombre-protagonista">Eustaquio &nbsp;Carrasco</h1>
      <h1 class="nombre-protagonista">Maricela &nbsp;Carrasco</h1>
       <div class="separador-elegante"></div>
 -->
      <p class="parrafo-presentacion">      <br>

      Under a sky filled with dreams and stars, we invite you to celebrate our daughter's fifteenth birthday,
who lights up our lives like a star in the sky. <br> We would love to share this special moment with those who hold a place in our hearts.
      </p>

      <!-- ✨ PADRINOS -->
     
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = [
        '.flor-1',
        '.flor-2',
        '.flor-3',
        '.flor-4',
        '.flor-5',
        '.flor-6'
      ].flatMap($)

      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.parrafo-presentacion'
      ].flatMap($)

      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-8, 6),
              duration: 0.9,
              stagger: 0.12
            },
            '-=0.6'
          )

          // ✨ TEXTO ENTRANDO CONSECUTIVO (PADRES → TEXTO → PADRINOS)
          tl.to(texto, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.18
          }, '-=0.3')

          // FLORES FLOTANTES
          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 14)}`,
              x: `+=${gsap.utils.random(-6, 6)}`,
              rotation: gsap.utils.random(-0.8, 0.8),
              duration: gsap.utils.random(2.8, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.2
            })
          })

          gsap.to(foto, {
            scale: 1.015,
            duration: 3.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
}, {
  threshold: 0.15,
  rootMargin: '0px 0px -120px 0px'
})
      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* TODO TU CSS ORIGINAL SE MANTIENE */

.flor-4{
  top: 80px;
  left: -10px;
    transform: translateX(-50%) rotate(-12deg);

  width: min(40vw, 200px);
  z-index: 6;
}
.flor-5{
  bottom: 30px;
      transform: translateX(-50%) rotate(-12deg);
opacity: 0 !important;

  right: -20px;
  width: min(46vw, 240px);
  z-index: 8;
}
.flor-6{
  top: 420px;
    transform: translateX(-50%) rotate(-12deg);
  right: -120px;
  width: min(34vw, 180px) !important;
  z-index: 3;
}
</style>


<style scoped>
.portada-xv{
  width:100%;
  min-height:100vh;
  position: relative;
  margin-top: -0px;
  left: 0;
  width: 100%;
  height: 100%;
background-image: 
  linear-gradient(to bottom, 
    rgba(0, 0, 0, 0.516) 60%, 
    rgba(0, 0, 0, 0.7) 85%, 
    rgba(0, 0, 0, 0.95) 100%
  ),
  url('@/assets/descarga (3).png');  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -3;
  overflow:visible;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:48px 16px 56px;
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#eeeee8;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 38px;
  color:#ac8a56;
  margin: 0 0 8px 0;
  text-shadow: 
    0 1px 2px rgba(0, 0, 0, 0.35);
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#e3dfdf;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:-20px; left:-100px; z-index:5; }
.flor-2{ top:60px; right:-80px; transform: rotate(-80deg); z-index:1; width:min(40vw, 220px) !important;  }
.flor-3{ bottom:-100px; left:-80px; transform: rotate(-30deg); z-index:9;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:120px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  opacity:0 !important;
  will-change: transform;
}
.bola-izquierda{ left:-20px; bottom:-50px; z-index:9;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>
